<template>
  <div class="table-con">

    <div class="lx-search-con">
      <Form ref="searchForm" :model="searchData" inline @keydown.native.enter.prevent="getLists">

        <slot name="searchFormItem"></slot>

        <FormItem v-if="showSearchForm">
          <Button :disabled="showLoading" type="primary" @click="searchAndResetPage()" icon="ios-search">搜索</Button>
        </FormItem>
        <FormItem v-if="showSearchForm">
          <Button :disabled="showLoading" type="primary" @click="resetSearchForm()">重置</Button>
        </FormItem>

        <slot name="otherBtn"></slot>
      </Form>

    </div>


    <Table border
           :columns="tableTitle"
           :data="dataLists"
           :ref="tabelRef"
           :height="sonTableHeight"
           :highlight-row="true"
           @on-row-click="rowClick"
           @on-selection-change="onSelectChange"
           @on-sort-change="onSortChange"
           :loading = "showLoading"
           row-key="rowKey">
    </Table>
    <div class="page">
      <Page show-sizer show-elevator show-total transfer v-if="showPage"
            :total="totalCount"
        :page-size-opts="pageSizeOptions"
            :page-size="currentPageSize"
            @on-change="changePage"
            :current="currentPage"
            @on-page-size-change="changePageSize"
      />
    </div>
  </div>
</template>

<script>
  export default {
    name: "pageTable",
    props:{
      tabelRef:{
        type:String,
        default:'table'
      },
      tableHeight:{
        type:Number,
      },
      tableTitle:{
        type:Array,
        default: ()=>[]
      },
      //是否显示页码
      showPage:{
        type: Boolean,
        default: true
      },
      showSearchForm:{
        type: Boolean,
        default: true
      },
      autoLoad:{
        type: Boolean,
        default: true
      },
      searchData:{
        type:Object,
        default:()=>{return {}}
      },
      defaultSearchParam:{
        type:Object,
        default:()=>{return {}}
      },
      tableApi:{
        type:String,
        default: ''
      },
      doneFunction:{
        type:Function,
        default:()=>{}
      },
      tableData:{
        type:Array,
        default:()=>[],
      },
      onSelectChange:{
        type:Function,
        default:()=>{}
      },
      onSortChange:{
        type:Function,
        default:()=>{}
      },
      rowKey:{
        type:String,
        default:'id',
      },
      defaultPageSize:{
        type:Number,
        default:100,
      },
      pageSizeOptions:{
        type:Array,
        default:()=>[10,20,50,100]
      },
      countOnFirstPageOnly:{
        type:Boolean,
        default:false
      }
    },
    data(){
      return {
        sonTableHeight:this.tableHeight,
        currentPage:1,
        currentPageSize:this.defaultPageSize,
        dataLists:[],
        totalCount:0,      //数据总条数
        showLoading:false,
      }
    },
    methods:{
      searchAndResetPage() {
        this.currentPage = 1;
        this.getLists();
      },
      changePage(page){
        this.currentPage = page
        this.getLists()
      },
      changePageSize(page_size){
        this.currentPageSize = page_size
        this.getLists()
      },
      setTableHeight(){
        //父组件设置了高度则固定高度，未设置高度则自适应
        if (this.tableHeight) {
          this.sonTableHeight = this.tableHeight
          return
        }
        const tableRef = this.$refs[this.tabelRef]
        if (!tableRef) {
          return
        }
        //视口高度过小时（如手机横屏），计算结果可能过小甚至为负导致表格内容不可见，兜底最小高度
        const autoHeight = window.innerHeight - tableRef.$el.offsetTop - (this.showPage ? 200 : 150)
        this.sonTableHeight = Math.max(autoHeight, 300)
      },
      handleWindowResize(){
        this.setTableHeight()
      },
      resetSearchForm(){
        if (this.$refs.searchForm) {
          this.$refs.searchForm.resetFields()
        }
        this.currentPage = 1
        this.getLists()
      },
      async getLists(){
        this.showLoading = true
        let apiUrl = this.tableApi;
        let params = {};
        params['page'] = this.currentPage
        params['pagesize'] = this.currentPageSize
        for (let key in this.defaultSearchParam){
          params[key] = this.defaultSearchParam[key]
        }
        for (let key in this.searchData){
          params[key] = this.searchData[key]
        }
        if (this.countOnFirstPageOnly){
          params['need_count'] = this.currentPage === 1 ? 1 : 0
          if (params['need_count'] === 0 && this.totalCount > 0){
            params['total_count'] = this.totalCount
          }
        }

        let res = await this.$commonFun.postProxy(apiUrl,params)
        // 先调用 doneFunction 处理数据格式
        res = this.doneFunction(res) || res
        // 再赋值给 dataLists
        this.dataLists = res.data
        if (this.countOnFirstPageOnly){
          if (Number(params['need_count']) === 1 || Number(res.count) > 0){
            this.totalCount = Number(res.count) || 0
          }
        }else{
          this.totalCount = res.count
        }
        this.showLoading = false
      },
      rowClick(currentRow){
        this.$emit('on-row-change',currentRow)
      }
    },
    mounted(){
      this.$nextTick(function () {
        this.setTableHeight()
      })
      //用 addEventListener 替代 window.onresize 直接赋值：同一页面多个表格会互相覆盖监听，
      //导致手机横竖屏切换时部分表格高度不更新
      window.addEventListener('resize', this.handleWindowResize)
      if (this.tableApi && this.autoLoad){
        this.getLists()
      }else if (!this.tableApi){
        this.dataLists = this.tableData
        this.totalCount = this.dataLists.length
      }
    },
    beforeDestroy(){
      window.removeEventListener('resize', this.handleWindowResize)
    },
    watch:{
      sonTableHeight (val) {
        this.sonTableHeight = val
      },
      tableData(val){
        this.dataLists = val
        this.totalCount = this.dataLists.length
      },
      tableHeight(){
        this.setTableHeight()
      }
    }

  }
</script>

<style scoped lang="less">
  .table-con{
    ::-webkit-scrollbar {
      /*滚动条整体样式*/
      width : 15px;  /*高宽分别对应横竖滚动条的尺寸*/
      height: 15px;
    }
    ::-webkit-scrollbar-thumb {
      /*滚动条里面小方块*/
      border-radius   : 10px;
      background-color: skyblue;
      background-image: -webkit-linear-gradient(
              45deg,
              rgba(255, 255, 255, 0.2) 25%,
              transparent 25%,
              transparent 50%,
              rgba(255, 255, 255, 0.2) 50%,
              rgba(255, 255, 255, 0.2) 75%,
              transparent 75%,
              transparent
      );
    }
      ::-webkit-scrollbar-track {
        /*滚动条里面轨道*/
        box-shadow   : inset 0 0 5px rgba(0, 0, 0, 0.2);
        background   : #ededed;
        border-radius: 10px;
      }
    .page{
      position: relative;
      margin-top: 10px;
      left: 20px;
    }
  }
</style>
